import { ROLE_COLORS } from '../muscles/catalog'
import { getPoseById } from '../poses/library'
import { useAppStore } from '../store'

export function ViewportCards() {
  const poseId = useAppStore((s) => s.poseId)
  const cardsMode = useAppStore((s) => s.cardsMode)
  const phase = useAppStore((s) => s.phase)
  const pose = getPoseById(poseId)
  if (!pose || cardsMode === 'off') return null

  const muscles = pose.muscles.filter((m) => {
    if (cardsMode === 'working-stabilizing') return m.role === 'working' || m.role === 'stabilizer'
    return true
  })

  const byRole = {
    working: muscles.filter((m) => m.role === 'working'),
    stabilizer: muscles.filter((m) => m.role === 'stabilizer'),
    lengthening: muscles.filter((m) => m.role === 'lengthening'),
  }

  return (
    <div className="viewport-cards" aria-live="polite">
      <div className="card phase-card">
        <strong>{pose.english}</strong>
        <span className="muted">{pose.sanskrit}</span>
        <span className="phase-pill">{phase}</span>
      </div>
      {(['working', 'stabilizer', 'lengthening'] as const).map((role) => {
        if (cardsMode === 'working-stabilizing' && role === 'lengthening') return null
        if (!byRole[role].length) return null
        return (
          <div key={role} className="card muscle-card">
            <div className="card-head">
              <span className="swatch" style={{ background: ROLE_COLORS[role] }} />
              <strong>{role === 'stabilizer' ? 'Stabilizing' : role[0].toUpperCase() + role.slice(1)}</strong>
            </div>
            <ul>
              {byRole[role].map((m) => (
                <li key={`${m.id}-${m.role}`}>
                  {m.name}
                  {!m.hasMesh && <em className="no-mesh"> (cards only)</em>}
                </li>
              ))}
            </ul>
          </div>
        )
      })}
      <p className="card disclaimer">Expected teaching involvement — not EMG % or diagnosis.</p>
    </div>
  )
}
